import { ActionTree } from "vuex";
import { ActionCallback, RootState } from "../types";
import { AuthState } from "./types";
import AuthService from "@/services/auth.service";
import { AxiosError, AxiosResponse } from "axios";
const service: AuthService = new AuthService();

export const actions: ActionTree<AuthState, RootState> = {
  getSelf({ state }, callback: ActionCallback) {
    service
      .getSelf()
      .then((response: AxiosResponse) => {
        if (response?.data) {
          state.user = response.data.data;
          if (callback && callback.success) callback.success(response);
        }
      })
      .catch((error: AxiosError) => {
        if (callback && callback.fail) callback.fail(error);
      })
      .finally(() => {
        if (callback && callback.finally) callback.finally();
      });
  },
  register(_, callback: ActionCallback) {
    service
      .register(callback?.params)
      .then((response: AxiosResponse) => {
        if (response?.data) {
          if (callback && callback.success) callback.success(response);
        }
      })
      .catch((error: AxiosError) => {
        if (callback && callback.fail) callback.fail(error);
      })
      .finally(() => {
        if (callback && callback.finally) callback.finally();
      });
  },
  login(_, callback: ActionCallback) {
    service
      .login(callback?.params)
      .then((response: AxiosResponse) => {
        if (response?.data) {
          if (callback && callback.success) callback.success(response);
        }
      })
      .catch((error: AxiosError) => {
        if (callback && callback.fail) callback.fail(error);
      })
      .finally(() => {
        if (callback && callback.finally) callback.finally();
      });
  },
  sendForgotPassword(_, callback: ActionCallback) {
    service
      .sendForgotPassword(callback?.params)
      .then((response: AxiosResponse) => {
        if (response?.data) {
          if (callback && callback.success) callback.success(response);
        }
      })
      .catch((error: AxiosError) => {
        if (callback && callback.fail) callback.fail(error);
      })
      .finally(() => {
        if (callback && callback.finally) callback.finally();
      });
  },
  changeForgotPassword(_, callback: ActionCallback) {
    service
      .changeForgotPassword(callback?.params)
      .then((response: AxiosResponse) => {
        if (response?.data) {
          if (callback && callback.success) callback.success(response);
        }
      })
      .catch((error: AxiosError) => {
        if (callback && callback.fail) callback.fail(error);
      })
      .finally(() => {
        if (callback && callback.finally) callback.finally();
      });
  },
  editProfile(_, callback: ActionCallback) {
    service
      .editProfile(callback?.params)
      .then((response: AxiosResponse) => {
        if (response?.data) {
          if (callback && callback.success) callback.success(response);
        }
      })
      .catch((error: AxiosError) => {
        if (callback && callback.fail) callback.fail(error);
      })
      .finally(() => {
        if (callback && callback.finally) callback.finally();
      });
  },
  sendLoginOtp(_, callback: ActionCallback) {
    service
      .sendLoginOtp(callback?.params)
      .then((response: AxiosResponse) => {
        if (response?.data) {
          if (callback && callback.success) callback.success(response);
        }
      })
      .catch((error: AxiosError) => {
        if (callback && callback.fail) callback.fail(error);
      })
      .finally(() => {
        if (callback && callback.finally) callback.finally();
      });
  },
  validateLoginOtp(_, callback: ActionCallback) {
    service
      .validateLoginOtp(callback?.params)
      .then((response: AxiosResponse) => {
        if (response?.data) {
          if (callback && callback.success) callback.success(response);
        }
      })
      .catch((error: AxiosError) => {
        if (callback && callback.fail) callback.fail(error);
      })
      .finally(() => {
        if (callback && callback.finally) callback.finally();
      });
  },
  sendRegisterOtp(_, callback: ActionCallback) {
    service
      .sendRegisterOtp(callback?.params)
      .then((response: AxiosResponse) => {
        if (response?.data) {
          if (callback && callback.success) callback.success(response);
        }
      })
      .catch((error: AxiosError) => {
        if (callback && callback.fail) callback.fail(error);
      })
      .finally(() => {
        if (callback && callback.finally) callback.finally();
      });
  },
  validateRegisterOtp(_, callback: ActionCallback) {
    service
      .validateRegisterOtp(callback?.params)
      .then((response: AxiosResponse) => {
        if (response?.data) {
          if (callback && callback.success) callback.success(response);
        }
      })
      .catch((error: AxiosError) => {
        if (callback && callback.fail) callback.fail(error);
      })
      .finally(() => {
        if (callback && callback.finally) callback.finally();
      });
  },
  loginWithGoogle(_, callback: ActionCallback) {
    service
      .loginWithGoogle(callback?.params)
      .then((response: AxiosResponse) => {
        if (response?.data) {
          if (callback && callback.success) callback.success(response);
        }
      })
      .catch((error: AxiosError) => {
        if (callback && callback.fail) callback.fail(error);
      })
      .finally(() => {
        if (callback && callback.finally) callback.finally();
      });
  },
};
